export default __webpack_public_path__ + "images/online-payment/visa-electron.svg?8ade95e65e3348e386b8a28e43b40c4e5c4ba7c22094b6240e7f2a2ed4243ee5";